import script from "./PaginacaoDaListagem.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginacaoDaListagem.vue?vue&type=script&setup=true&lang=js"

import "./PaginacaoDaListagem.vue?vue&type=style&index=0&id=d994b400&scoped=true&lang=css"

import exportComponent from "/home/ewerson/Projetos/vue/vitrine_digital/vitrine-crescimentoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d994b400"]])

export default __exports__